document.addEventListener("DOMContentLoaded", function() {
  
  const step2 = document.getElementById('pdp-step-2');
  if (!step2) return;

  const flowType = step2.getAttribute('data-flow-type') || '1';

  const triggerBtn = document.querySelector('[id^="CompleteLookBtn-"]'); 
  const mainForm = document.querySelector('form[action*="/cart/add"]');
  const step1 = document.getElementById('pdp-step-1');
  const ui1 = document.getElementById('flow-ui-1');
  const ui2 = document.getElementById('flow-ui-2');
  const subtotalEl = document.getElementById('BundleSubtotal');
  const firstStepSubtotal = document.getElementById('Step1Subtotal');
  const productCollections = document.querySelector('.product__collections');

  const standardAddBtn = document.querySelector('.product-form__submit');
  const dynamicPayment = document.querySelector('.shopify-payment-button');

  const stickyColumn = document.querySelector('.product__column-sticky');
  const infoContainer = document.querySelector('.product__info-container');

  if (stickyColumn && infoContainer) {
      const removeSticky = () => {

          if (window.innerWidth < 750) return;

          if (stickyColumn.classList.contains('disable-sticky')) return;
          
          stickyColumn.classList.add('disable-sticky');
          
          setTimeout(() => {
              const y = infoContainer.getBoundingClientRect().top + window.scrollY - 132;
              window.scrollTo({ top: y, behavior: 'smooth' });
          }, 50); 
      };

      ['input', 'change', 'click'].forEach(eventType => {
          infoContainer.addEventListener(eventType, removeSticky);
      });
  }

  function updateAvailabilityUI(variant) {
      if (!variant) return;

      if (variant.available) {
          if (standardAddBtn) standardAddBtn.style.display = 'none';
          if (dynamicPayment) dynamicPayment.style.display = 'none';
          
          if (triggerBtn) triggerBtn.style.display = 'block';
          if (firstStepSubtotal) firstStepSubtotal.style.display = 'block';
      } else {
          if (standardAddBtn) standardAddBtn.style.display = 'block';
          if (dynamicPayment) dynamicPayment.style.display = 'block';
          
          if (triggerBtn) triggerBtn.style.display = 'none';
          if (firstStepSubtotal) firstStepSubtotal.style.display = 'none';
      }
  }

  const initialIdInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  if (initialIdInput && window.pdpVariants) {
      const initialId = parseInt(initialIdInput.value);
      const initialVariant = window.pdpVariants.find(v => v.id === initialId);
      updateAvailabilityUI(initialVariant);
  }

  if (flowType === '2' && ui2) {
      ui2.style.display = 'block';
  } else if (ui1) {
      ui1.style.display = 'block';
  }

  const variantSelectors = document.querySelectorAll('.bundle-variant-selector');
  variantSelectors.forEach(select => {
      const defaultVal = select.getAttribute('data-default-value');
      if (defaultVal && select.value !== defaultVal) {
          select.value = defaultVal;
          select.dispatchEvent(new Event('change'));
      }
  });

  function updateSummaryImageFromVariant() {
      const summaryImg = document.querySelector('.summary-img');
      const mainIdInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      
      if (!summaryImg || !mainIdInput || !window.pdpVariants) return;

      const currentId = parseInt(mainIdInput.value);
      const matchedVariant = window.pdpVariants.find(v => v.id === currentId);

      if (matchedVariant && matchedVariant.featured_image && matchedVariant.featured_image.src) {
          summaryImg.src = matchedVariant.featured_image.src;
          summaryImg.removeAttribute('srcset');
      }
  }

  function syncMainVariantState() {
      const mainIdInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (!mainIdInput || !window.pdpVariants) return;

      const currentId = parseInt(mainIdInput.value);
      const matchedVariant = window.pdpVariants.find(v => v.id === currentId);

      if (matchedVariant) {
          updateAvailabilityUI(matchedVariant);

          step2.setAttribute('data-main-price', matchedVariant.price);
          const formattedPrice = '$' + (matchedVariant.price / 100).toFixed(2);

          if (firstStepSubtotal) firstStepSubtotal.innerText = 'SUBTOTAL: ' + formattedPrice;
          
          const summaryPriceEl = document.querySelector('.summary-price');
          if (summaryPriceEl) summaryPriceEl.innerText = formattedPrice;

          const sizeSpan = document.getElementById('SummarySizeText');
          if (sizeSpan && sizeSpan.getAttribute('data-dynamic') === 'true') {
              const optKey = sizeSpan.getAttribute('data-option-key');
              if (optKey && matchedVariant[optKey]) {
                  sizeSpan.innerText = matchedVariant[optKey];
              }
          }

          updateBundleTotals();
      }
  }

  if (mainForm) {
      mainForm.addEventListener('change', () => {
          setTimeout(() => {
              updateSummaryImageFromVariant();
              syncMainVariantState();
          }, 50);
      });
  }

  if (triggerBtn && step1 && step2) {
      triggerBtn.addEventListener('click', (e) => {
          e.preventDefault();

          let isValid = true;
          
          const easifyInputs = document.querySelectorAll('.tpo_option-input, .tpo_text-box, .tpo_option-container textarea, .tpo_option-container select');

          easifyInputs.forEach(input => {
              const isRequired = input.getAttribute('data-required') === '1' || 
                                 input.hasAttribute('required') || 
                                 input.closest('.tpo_option-container')?.querySelector('.tpo_option-required-indicator');
              
              const container = input.closest('.tpo_option-container');
              const isHidden = container && (container.classList.contains('tpo_hidden') || window.getComputedStyle(container).display === 'none');
              const errorDiv = container ? container.querySelector('.tpo_error-message') : null;
              
              if (errorDiv) {
                  errorDiv.style.display = 'none';
                  errorDiv.innerText = '';
              }
              input.style.border = '';

              if (isRequired && !isHidden) {
                  if (!input.value || input.value.trim() === '') {
                      isValid = false;
                      input.style.border = '1px solid #d04343';

                      if (errorDiv) {
                          errorDiv.style.display = 'block';
                          errorDiv.innerText = "This field is required"; 
                          errorDiv.style.color = '#d04343';
                          errorDiv.style.marginTop = '5px';
                          errorDiv.style.fontSize = '13px';
                          errorDiv.style.fontWeight = '500';
                      }
                  }
              }
          });

          if (!isValid) {
              const firstError = document.querySelector('.tpo_error-message[style*="block"]');
              if (firstError) {
                  firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
              return;
          }

          populateSummaryHeader();
          updateSummaryImageFromVariant();
          syncMainVariantState();
          
          step1.style.display = 'none';
          if (firstStepSubtotal) firstStepSubtotal.style.display = 'none';
          if (productCollections) productCollections.style.display = 'none';
          
          step2.style.display = 'block';
          setTimeout(() => step2.classList.add('active'), 10);
          window.scrollTo({ top: 0, behavior: 'smooth' });
          updateBundleTotals();
      });
  }

  const backBtn = document.getElementById('Step2BackBtn');
  if (backBtn) {
      backBtn.addEventListener('click', (e) => {
          e.preventDefault();
          step2.classList.remove('active');
          step2.style.display = 'none';
          
          step1.style.display = 'block';
          if (productCollections) productCollections.style.display = 'block';
          if (firstStepSubtotal) firstStepSubtotal.style.display = 'block';
      });
  }

  const noVaseCb = document.getElementById('NoVaseCheckbox');
  if (noVaseCb) {
      noVaseCb.addEventListener('change', function() {
          if (this.checked) {
              document.querySelectorAll('.bundle-card[data-group="vase"].selected').forEach(c => c.classList.remove('selected'));
              
              const errorDiv = document.getElementById('VaseSelectionError');
              if (errorDiv) errorDiv.style.display = 'none';

              updateBundleTotals();
          }
      });
  }

  const cards = document.querySelectorAll('.bundle-card, .accessory-row');
  
  cards.forEach(card => {
      card.addEventListener('click', function() {

          if (this.classList.contains('out-of-stock')) return;
          
          const group = this.getAttribute('data-group');

          if (group === 'vase-variant') {
             if (this.classList.contains('selected')) return;
             document.querySelectorAll('.bundle-card[data-group="vase-variant"]').forEach(c => c.classList.remove('selected'));
             this.classList.add('selected');

             const pos = this.getAttribute('data-option-position'); 
             const val = this.getAttribute('data-value');

             if (window.pdpCurrentOptions && window.pdpVariants && pos) {
                 window.pdpCurrentOptions[pos] = val;
                 const matched = window.pdpVariants.find(v => {
                     return Object.keys(window.pdpCurrentOptions).every(k => !v[k] || v[k] === window.pdpCurrentOptions[k]);
                 });

                 if (matched) {
                     const hiddenId = document.querySelector('input[name="id"]');
                     if(hiddenId) {
                         hiddenId.value = matched.id;
                         hiddenId.dispatchEvent(new Event('change', { bubbles: true }));
                     }
                 }
             }
          }
          else if (group === 'vase') {
             const current = document.querySelector('.bundle-card[data-group="vase"].selected');
             if (current && current !== this) current.classList.remove('selected');
             this.classList.toggle('selected');

             if (this.classList.contains('selected')) {
                 if (noVaseCb) noVaseCb.checked = false;
                 const errorDiv = document.getElementById('VaseSelectionError');
                 if (errorDiv) errorDiv.style.display = 'none';
             }
          } 
          else {
             this.classList.toggle('selected');
          }
          updateBundleTotals();
      });
  });

  document.querySelectorAll('.bundle-variant-selector').forEach(select => {
      select.addEventListener('click', e => e.stopPropagation());
      
      select.addEventListener('change', function(e) {
          const card = this.closest('.bundle-card');
          const opt = this.options[this.selectedIndex];
          
          if(card) {
             const newId = this.value;
             const newPriceCents = parseFloat(opt.getAttribute('data-price'));
             const newImageSrc = opt.getAttribute('data-image');

             card.setAttribute('data-id', newId);
             card.setAttribute('data-price', newPriceCents);
             
             const priceDisplay = card.querySelector('.bundle-card__price');
             if (priceDisplay && !isNaN(newPriceCents)) {
                 priceDisplay.innerText = '$' + (newPriceCents / 100).toFixed(2);
             }

             const imgEl = card.querySelector('.bundle-card__img');
             if (imgEl && newImageSrc) {
                 imgEl.src = newImageSrc;
                 imgEl.removeAttribute('srcset'); 
             }

             if (!card.classList.contains('selected')) card.classList.add('selected');
             updateBundleTotals();
          }
      });
  });

  function updateBundleTotals() {
    if (!subtotalEl || !step2) return;
    
    const mainPrice = parseFloat(step2.getAttribute('data-main-price')) || 0;
    let accPrice = 0;
    let itemCount = 1;

    document.querySelectorAll('.bundle-card[data-group="pair"].selected, .bundle-card[data-group="vase"].selected').forEach(el => {
        const p = parseFloat(el.getAttribute('data-price'));
        if (!isNaN(p)) { 
            accPrice += p; 
            itemCount++; 
        }
    });

    const total = mainPrice + accPrice;
    subtotalEl.innerText = `SUBTOTAL: (${itemCount} ${itemCount === 1 ? 'Item' : 'Items'}) $${(total / 100).toFixed(2)}`;
  }

  function populateSummaryHeader() {
      const typeInput = document.querySelector('[name*="properties"][name*="Delivery Type"]');
      const typeSpan = document.getElementById('SummaryDeliveryType');
      if (typeSpan) typeSpan.innerText = (typeInput && typeInput.value) ? typeInput.value : 'Not selected';

      const dateInputs = document.querySelectorAll('[name*="properties"][name*="Date"]');
      const dateSpan = document.getElementById('SummaryDeliveryDate');
      let foundDate = null;
      dateInputs.forEach(i => { if (i.value && i.value.trim() !== "") foundDate = i.value; });
      if (dateSpan) dateSpan.innerText = foundDate || 'Not selected';

      const msgCheckbox = document.querySelector('[name*="properties"][name*="Add Personalized Message"]');
      const msgSpan = document.getElementById('SummaryMessage');
      if (msgSpan) {
          const isChecked = msgCheckbox && (msgCheckbox.checked || msgCheckbox.value === 'Yes');
          msgSpan.innerText = isChecked ? 'Yes' : 'No';
      }
  }

  function submitBundle() {
      const btn = document.getElementById('BundleAddToCart');
      if (!btn) return;

      const isFlow1 = step2.getAttribute('data-flow-type') === '1' || step2.getAttribute('data-flow-type') == null;
      if (isFlow1) {
          const hasVaseOptions = document.querySelectorAll('#flow-ui-1 .bundle-card[data-group="vase"]').length > 0;
          if (hasVaseOptions) {
              const vaseSelected = document.querySelector('#flow-ui-1 .bundle-card[data-group="vase"].selected');
              const errorDiv = document.getElementById('VaseSelectionError');
              
              if (!vaseSelected && (!noVaseCb || !noVaseCb.checked)) {
                  if (errorDiv) {
                      errorDiv.style.display = 'block';
                      errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }
                  return;
              }
          }
      }

      const originalHTML = btn.innerHTML;
      btn.classList.add('loading');
      btn.innerText = 'Adding...';
      btn.disabled = true;

      const itemsToAdd = [];
      const mainIdInput = document.querySelector('input[name="id"]');
      const mainQtyInput = document.querySelector('input[name="quantity"]');
      
      const mainId = mainIdInput ? mainIdInput.value : null;
      const mainQty = mainQtyInput ? mainQtyInput.value : 1;
      const mainProps = {};

      if (!mainId) {
          console.error("Main product ID missing");
          return;
      }

      document.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]').forEach(input => {
          if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) return;
          if (input.value.trim() === '') return;
          const match = input.name.match(/properties\[(.*?)\]/);
          if (match && match[1]) mainProps[match[1]] = input.value;
      });

      itemsToAdd.push({ id: parseInt(mainId), quantity: parseInt(mainQty), properties: mainProps });

      document.querySelectorAll('.bundle-card[data-group="pair"].selected, .bundle-card[data-group="vase"].selected').forEach(el => {
          const id = el.getAttribute('data-id');
          if(id) itemsToAdd.push({ id: parseInt(id), quantity: 1 });
      });

      fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
      })
      .then(res => res.json())
      .then(data => {
          if (data.status === 422) throw new Error(data.description);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          btn.classList.remove('loading');
          btn.innerText = 'Added!';
          setTimeout(() => { btn.disabled = false; btn.innerHTML = originalHTML; }, 1500);
      })
      .catch(err => {
          console.error(err);
          btn.classList.remove('loading');
          btn.disabled = false;
          btn.innerText = 'Error';
      });
  }

  const bundleAddBtn = document.getElementById('BundleAddToCart');
  if (bundleAddBtn) bundleAddBtn.addEventListener('click', submitBundle);

});